(() => {
  const trackerSelector = '[data-free-shipping-tracker]';
  const mutationPattern = /\/cart\/(?:add|change|update|clear)(?:\.js)?(?:\?|$)/;

  const localeFor = (locale) => {
    const locales = {
      ar: 'ar',
      de: 'de-DE',
      en: 'en-GB',
      es: 'es-ES',
      hi: 'hi-IN',
      it: 'it-IT',
      ja: 'ja-JP',
      ko: 'ko-KR',
      nl: 'nl-NL',
      pl: 'pl-PL',
      'pt-BR': 'pt-BR',
      'pt-PT': 'pt-PT',
      tr: 'tr-TR',
      'zh-CN': 'zh-CN'
    };

    return locales[locale] || 'fr-FR';
  };

  const formatAmount = (amount, root) => {
    const locale = localeFor(root.dataset.locale);
    const currency = root.dataset.currency || 'EUR';

    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: amount % 100 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    }).format(amount / 100);
  };

  const setMessage = (message, before, amount, after) => {
    message.replaceChildren();
    message.append(document.createTextNode(`${before} `));

    const amountElement = document.createElement('strong');
    amountElement.textContent = amount;
    message.append(amountElement);

    if (after) {
      message.append(document.createTextNode(` ${after}`));
    }
  };

  const setDetailMessage = (message, title, before, amount, after) => {
    message.replaceChildren();
    const titleElement = document.createElement('strong');
    titleElement.textContent = title;
    const detail = document.createElement('span');
    detail.append(document.createTextNode(`${before} `));
    const amountElement = document.createElement('b');
    amountElement.textContent = amount;
    detail.append(amountElement);
    if (after) {
      detail.append(document.createTextNode(` ${after}`));
    }
    message.append(titleElement, document.createElement('br'), detail);
  };

  const setCompletionMessage = (message, title, detail) => {
    message.replaceChildren();
    const titleElement = document.createElement('strong');
    titleElement.textContent = title;
    const detailElement = document.createElement('span');
    detailElement.textContent = detail;
    message.append(titleElement, document.createElement('br'), detailElement);
  };

  const updateTracker = (root, cartTotal) => {
    const deliveryThreshold = Number(root.dataset.threshold);
    const surpriseThreshold = Number(root.dataset.surpriseThreshold) || deliveryThreshold;
    const message = root.querySelector('[data-free-shipping-message]');
    const fill = root.querySelector('[data-free-shipping-fill]');
    const deliveryDot = root.querySelector('[data-free-shipping-delivery-dot]');
    const surpriseDot = root.querySelector('[data-free-shipping-surprise-dot]');

    if (!deliveryThreshold || !message || !fill || !deliveryDot || !surpriseDot) return;

    const deliveryUnlocked = cartTotal >= deliveryThreshold;
    const surpriseUnlocked = cartTotal >= surpriseThreshold;
    const deliveryRemaining = Math.max(deliveryThreshold - cartTotal, 0);
    const surpriseRemaining = Math.max(surpriseThreshold - cartTotal, 0);
    root.classList.toggle('is-unlocked', deliveryUnlocked);
    root.classList.toggle('is-delivery-unlocked', deliveryUnlocked);
    root.classList.toggle('is-surprise-unlocked', surpriseUnlocked);
    const progress = deliveryUnlocked
      ? 50 + ((cartTotal - deliveryThreshold) / (surpriseThreshold - deliveryThreshold)) * 50
      : (cartTotal / deliveryThreshold) * 50;
    fill.style.width = `${Math.max(0, Math.min(progress, 100))}%`;

    if (surpriseUnlocked) {
      setCompletionMessage(
        message,
        root.dataset.surpriseComplete,
        root.dataset.surpriseCompleteDetail
      );
      return;
    }

    if (deliveryUnlocked) {
      setDetailMessage(
        message,
        root.dataset.deliveryComplete,
        root.dataset.surpriseRemainingBefore,
        formatAmount(surpriseRemaining, root),
        root.dataset.surpriseRemainingAfter
      );
      return;
    }

    setMessage(
      message,
      root.dataset.remainingBefore,
      formatAmount(deliveryRemaining, root),
      root.dataset.remainingAfter
    );
  };

  const refreshTrackers = async () => {
    const trackers = document.querySelectorAll(trackerSelector);
    if (!trackers.length) return;

    try {
      const cartUrl = window.theme && window.theme.routes && window.theme.routes.cart_url
        ? window.theme.routes.cart_url
        : '/cart';
      const response = await fetch(`${cartUrl}.js`, { credentials: 'same-origin' });
      if (!response.ok) return;

      const cart = await response.json();
      trackers.forEach((tracker) => updateTracker(tracker, cart.total_price));
    } catch (error) {
      // The server-rendered state remains available if the cart refresh fails.
    }
  };

  const scheduleRefresh = () => window.setTimeout(refreshTrackers, 250);

  document.addEventListener('DOMContentLoaded', refreshTrackers, { once: true });
  document.addEventListener('cart:item-added', scheduleRefresh);
  document.addEventListener('line-item:change:end', scheduleRefresh);
  document.addEventListener('cart:remove', scheduleRefresh);

  const originalFetch = window.fetch.bind(window);
  window.fetch = (...args) => {
    const request = args[0];
    const url = typeof request === 'string' ? request : request && request.url;
    const response = originalFetch(...args);

    if (url && mutationPattern.test(url)) {
      response.then(scheduleRefresh).catch(() => {});
    }

    return response;
  };
})();
